import { themr } from '@friendsofreactjs/react-css-themr';
import InlineSection from './InlineSection';

export default themr('InlineSection')(InlineSection);
